module.exports = __webpack_public_path__ + "img/KSC03472.8de630ff.jpg";